import DispatchConstants from '../../constants/DispatchConstants';

const initState = () => ({
  listing: {},
  inquiry: {},
  phoneCallsByGuid: {},
});

const lead = (state = initState(), action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case DispatchConstants.LEAD_SUCCESS:
      return Object.assign({}, state, payload);

    case DispatchConstants.LEAD_FAIL:
      return state;

    default:
      return state;
  }
};

export default lead;
